"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9771],{

/***/ 75417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30132);
/* harmony import */ var _app_components_Portal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20901);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .dimmed {\n    position: fixed;\n    opacity: 0;\n    background: rgba(0, 0, 0, 0.7);\n    transition: opacity 0.15s ease-out;\n    z-index: 500;\n  }\n  .wrapper {\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-top-left-radius: 20px;\n    border-top-right-radius: 20px;\n    background: white;\n    transform: translateY(100%);\n    transition: transform 0.15s ease-out;\n    z-index: 500;\n  }\n  &.open {\n    .dimmed {\n      opacity: 1;\n      top: 0px;\n      left: 0px;\n      right: 0px;\n      bottom: 0px;\n    }\n    .wrapper {\n      transform: translateY(0%);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var BottomSheet = function(param) {
    var children = param.children, _open = param.open, open = _open === void 0 ? false : _open, onClose = param.onClose;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!open) return;
        if (typeof document !== "object") return;
        document.body.style.cssText = "\n        overflow: hidden;\n      ";
        return function() {
            document.body.style.cssText = "\n      ";
        };
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Portal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
            className: "".concat(open ? "open" : ""),
            onClick: onClose,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "dimmed",
                    children: " "
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "wrapper",
                    onClick: function(e) {
                        return e.stopPropagation();
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "header",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "close-btn",
                                children: " "
                            })
                        }),
                        children
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BottomSheet);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "BottomSheet__StyledWrapper",
    componentId: "sc-ca9da4d2-0"
})(_templateObject());


/***/ }),

/***/ 39771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ChannelNavbar_mobile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/app.components/Modal/Modal.tsx + 1 modules
var Modal = __webpack_require__(7029);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.search/component/SearchMobileHeader.tsx
var SearchMobileHeader = __webpack_require__(48002);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.search/screen/HotKeywordBoxList.tsx
var HotKeywordBoxList = __webpack_require__(2858);
;// CONCATENATED MODULE: ./src/app.feature/channel/channel.search/screen/ScreenChannelSearchModal.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  background-color: white;\n  .list-box {\n    padding-top: 108px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ScreenChannelSearchModal = function(_param) {
    var onClose = _param.onClose, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onClose"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onClose: onClose
    }, props), {
        animation: "left",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchMobileHeader/* default */.Z, {
                    title: "채널 검색",
                    onClose: onClose
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "list-box",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HotKeywordBoxList/* default */.Z, {})
                })
            ]
        })
    }));
};
/* harmony default export */ var screen_ScreenChannelSearchModal = (ScreenChannelSearchModal);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScreenChannelSearchModal__StyledWrapper",
    componentId: "sc-fbb9a63b-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/app.modules/hooks/useIsMobile.tsx
var useIsMobile = __webpack_require__(50516);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsWebview.tsx
var useIsWebview = __webpack_require__(67235);
// EXTERNAL MODULE: ./src/app.modules/util/index.tsx
var util = __webpack_require__(65677);
// EXTERNAL MODULE: ./src/app.styled/media.ts
var media = __webpack_require__(68250);
// EXTERNAL MODULE: ./src/components/LoginAlert.tsx
var LoginAlert = __webpack_require__(39749);
;// CONCATENATED MODULE: ./src/svgIcons/ChannelCardListBtn.tsx

function ChannelCardListBtn() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "aria-label": "채널 카드 리스트",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("desc", {
                children: "채널 카드 리스트"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "n9eixaqiza",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        stroke: "#707070",
                        d: "M0 0h24v24H0z",
                        "data-name": "사각형 11461",
                        opacity: "0.33"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#n9eixaqiza)",
                "data-name": "마스크 그룹 4464",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    fill: "none",
                    stroke: "#333",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1.8",
                    "data-name": "그룹 13615",
                    transform: "translate(5.352 6)",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                            cx: "3.018",
                            cy: "3.141",
                            "data-name": "타원 32",
                            rx: "3.018",
                            ry: "3.141",
                            transform: "translate(3.631)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M12.149 12.001a5.5 5.5 0 10-11 0",
                            "data-name": "패스 352"
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var svgIcons_ChannelCardListBtn = (ChannelCardListBtn);

// EXTERNAL MODULE: ./src/svgIcons/MagnifyingGlass.tsx
var MagnifyingGlass = __webpack_require__(8741);
;// CONCATENATED MODULE: ./src/svgIcons/TagFilterBtn.tsx

function TagFilterBtn(param) {
    var _color = param.color, color = _color === void 0 ? "#333" : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "aria-label": "태그 필터",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("desc", {
                children: "태그 필터"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "5xv1dfq3va",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        stroke: "#707070",
                        d: "M0 0h24v24H0z",
                        "data-name": "사각형 11461",
                        opacity: "0.33"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#5xv1dfq3va)",
                "data-name": "마스크 그룹 4464",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    fill: "none",
                    stroke: color,
                    strokeLinecap: "round",
                    strokeWidth: "1.5",
                    "data-name": "그룹 13614",
                    transform: "translate(5 5)",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M2 0v7.408",
                            "data-name": "패스 8195"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "2",
                            cy: "2",
                            r: "2",
                            strokeLinejoin: "round",
                            "data-name": "타원 1280",
                            transform: "rotate(90 -1.75 5.75)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            strokeLinejoin: "round",
                            d: "M7 6.5V14",
                            "data-name": "선 241"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "2",
                            cy: "2",
                            r: "2",
                            strokeLinejoin: "round",
                            "data-name": "타원 1281",
                            transform: "rotate(90 3.25 5.75)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            strokeLinejoin: "round",
                            d: "M12 0v7.5",
                            "data-name": "선 242"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "2",
                            cy: "2",
                            r: "2",
                            strokeLinejoin: "round",
                            "data-name": "타원 1282",
                            transform: "rotate(90 3.25 10.75)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            strokeLinejoin: "round",
                            d: "M12 11.5V14",
                            "data-name": "선 243"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            strokeLinejoin: "round",
                            d: "M7 0v2.5",
                            "data-name": "선 244"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M2 11.5V14",
                            "data-name": "패스 8196"
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var svgIcons_TagFilterBtn = (TagFilterBtn);

// EXTERNAL MODULE: ./src/app.components/tabs/LineTabs/LineTabs.tsx
var LineTabs = __webpack_require__(28912);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./src/app.components/BottomSheet/BottomSheet.tsx
var BottomSheet = __webpack_require__(75417);
// EXTERNAL MODULE: ./src/app.components/Button/index.tsx
var Button = __webpack_require__(85025);
// EXTERNAL MODULE: ./src/svgIcons/ResetTag.tsx
var ResetTag = __webpack_require__(80549);
;// CONCATENATED MODULE: ./src/app.feature/channel/channel.feed/screen/menus/ChannelFeedHome/ChannelFeedTagBox/TagBottomSheet.tsx




function TagBottomSheet_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query gqlTagBottomSheet {\n    TagBottomSheet: recommendNewsItemTagCollection {\n      ...ChannelFeedTagBox_TagCollection\n    }\n  }\n"
    ]);
    TagBottomSheet_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 400px;\n  padding: 28px 20px 11px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  .top {\n    overflow-y: scroll;\n    .tag-header {\n      display: flex;\n      gap: 15px;\n      margin-bottom: 30px;\n      .tag-header-item {\n        font-size: 14px;\n        font-weight: bold;\n        background: none;\n        border: none;\n        padding: 0px;\n        color: #bbb;\n        &[data-active='true'] {\n          color: #333;\n        }\n      }\n    }\n    .tag-list {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 5px;\n      overflow-y: scroll;\n      flex-grow: 0;\n      .tag-item {\n        border: none;\n        font-weight: 400;\n        line-height: 1.43;\n        border-radius: 30px;\n        background-color: #eee;\n        font-size: 12px;\n        padding: 6px 12px;\n        &[data-selected='true'] {\n          background-color: #01a0ff;\n          color: white;\n        }\n      }\n    }\n  }\n  .bottom {\n    .selected-tag-list {\n      display: flex;\n      overflow-x: scroll;\n      gap: 5px;\n      margin-bottom: 16px;\n      .tag-item {\n        color: hsl(0deg, 0%, 21%);\n        font-size: 12px;\n        background-color: #f2faff;\n        padding: 10px 15px;\n        border-radius: 5px;\n        border: 1px solid #d9e9f3;\n        flex-shrink: 0;\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        svg {\n          width: 8px;\n          height: 8px;\n        }\n      }\n    }\n    .btn-list {\n      display: flex;\n      .reset-btn {\n        font-size: 12px;\n        font-weight: bold;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 50px;\n        flex-grow: 1;\n      }\n      .search-btn {\n        font-size: 16px;\n        height: 50px;\n        flex-grow: 2;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












src_default()(TagBottomSheet_templateObject());
var TagBottomSheet = function(_param) {
    var onClose = _param.onClose, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onClose"
    ]);
    var router = (0,next_router.useRouter)();
    var data = (0,graphql/* useGqlTagBottomSheetQuery */.Kyi)().data;
    var ref = (0,react.useState)(null), selectedMenu = ref[0], setSelectedMenu = ref[1];
    var filteredData = (0,react.useMemo)(function() {
        var filteredData = [];
        if (!data || !data.TagBottomSheet) return;
        data.TagBottomSheet.forEach(function(tagCollection) {
            if (tagCollection.tags.nodes.length !== 0) filteredData.push(tagCollection);
        });
        return filteredData;
    }, [
        data
    ]);
    (0,react.useEffect)(function() {
        if (!filteredData || filteredData.length === 0) return;
        setSelectedMenu(filteredData[0].title);
        return function() {};
    }, [
        filteredData
    ]);
    var handleClickMenu = function(menu) {
        setSelectedMenu(menu);
    };
    var addTag = function(tag) {
        var tags = router.query.tags ? "".concat(router.query.tags).split(",") : [];
        var tagsSet = new Set(tags);
        tagsSet.add(tag);
        var newTags = Array.from(tagsSet).join(",");
        router.push({
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                tags: newTags
            })
        }, undefined, {
            scroll: false
        });
    };
    var deleteTag = function(tag) {
        var newQuery = router.query;
        var tags = router.query.tags ? "".concat(router.query.tags).split(",") : [];
        var tagsSet = new Set(tags);
        tagsSet.delete(tag);
        var newTags = Array.from(tagsSet).join(",");
        newQuery.tags = newTags;
        router.push({
            query: newQuery
        }, undefined, {
            scroll: false
        });
    };
    var handleReset = function() {
        var newQuery = (0,_object_spread/* default */.Z)({}, router.query);
        delete newQuery.tags;
    };
    var dataSet = (0,react.useMemo)(function() {
        var dataSet = {};
        if (!filteredData) return null;
        filteredData.forEach(function(tagItem) {
            dataSet[tagItem.title] = tagItem.tags.nodes.map(function(tag) {
                return tag;
            });
        });
        return dataSet;
    }, [
        filteredData
    ]);
    var selectedTagIds = (0,react.useMemo)(function() {
        return router.query.tags ? "".concat(router.query.tags).split(",") : [];
    }, [
        router.query.tags
    ]);
    var selectedTags = (0,react.useMemo)(function() {
        if (!data || !data.TagBottomSheet) return [];
        var tags = data.TagBottomSheet.reduce(function(prev, curr) {
            return prev.concat(curr.tags.nodes);
        }, []);
        var uniqueTagMap = tags.reduce(function(acc, tag) {
            acc.set(tag.id, tag);
            return acc;
        }, new Map());
        var uniqueTags = Array.from(uniqueTagMap.values());
        return uniqueTags.filter(function(tag) {
            return selectedTagIds.includes(tag.id);
        });
    }, [
        router.query.tags,
        data
    ]);
    if (!dataSet || !selectedMenu) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSheet/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onClose: onClose
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagBottomSheet_StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "top",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tag-header",
                            children: Object.keys(dataSet).map(function(header, idx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "tag-header-item",
                                    onClick: function() {
                                        return handleClickMenu(header);
                                    },
                                    "data-active": header === selectedMenu,
                                    children: header
                                }, idx);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tag-list",
                            children: dataSet[selectedMenu].map(function(tag, idx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: "tag-item",
                                    onClick: function() {
                                        return selectedTagIds.find(function(tagId) {
                                            return tagId === tag.id;
                                        }) ? deleteTag(tag.id) : addTag(tag.id);
                                    },
                                    "data-selected": !!selectedTagIds.find(function(tagId) {
                                        return tagId === tag.id;
                                    }),
                                    children: [
                                        "#",
                                        tag.name
                                    ]
                                }, idx);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bottom",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "selected-tag-list",
                            children: selectedTags.map(function(tag, idx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: "tag-item",
                                    onClick: function() {
                                        return deleteTag(tag.id);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: tag.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Close */.x8, {})
                                        })
                                    ]
                                }, idx);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "btn-list",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    onClick: handleReset,
                                    href: {
                                        query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                            tags: ""
                                        })
                                    },
                                    scroll: false,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "reset-btn",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResetTag/* default */.Z, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: "초기화"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: "search-btn",
                                    onClick: onClose,
                                    children: "소식보기"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var ChannelFeedTagBox_TagBottomSheet = (TagBottomSheet);
var TagBottomSheet_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TagBottomSheet__StyledWrapper",
    componentId: "sc-b8d8978a-0"
})(_templateObject1());

// EXTERNAL MODULE: ./src/app.feature/channel/component/ChannelSearchbar.tsx
var ChannelSearchbar = __webpack_require__(63319);
// EXTERNAL MODULE: ./src/app.feature/channel/component/cards/ChannelOwnerCard/ChannelOwnerCard.tsx
var ChannelOwnerCard = __webpack_require__(62618);
// EXTERNAL MODULE: ./src/svgIcons/MobileBack.tsx
var MobileBack = __webpack_require__(24285);
;// CONCATENATED MODULE: ./src/app.feature/channel/component/MobileHeader.tsx

function MobileHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: white;\n  .search-header {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 50px;\n    .back-btn {\n      position: absolute;\n      top: 17px;\n      left: 20px;\n      cursor: pointer;\n    }\n    .header-title {\n      font-size: 16px;\n      font-weight: bold;\n    }\n  }\n"
    ]);
    MobileHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var MobileHeader = function(param) {
    var onClose = param.onClose, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileHeader_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "search-header",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "back-btn",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBack/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "header-title",
                    children: title
                })
            ]
        })
    });
};
/* harmony default export */ var component_MobileHeader = (MobileHeader);
var MobileHeader_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MobileHeader__StyledWrapper",
    componentId: "sc-c10cafcd-0"
})(MobileHeader_templateObject());

// EXTERNAL MODULE: ./src/app.feature/channel/component/lists/FollowingListMobile.tsx
var FollowingListMobile = __webpack_require__(11834);
// EXTERNAL MODULE: ./src/app.feature/channel/component/lists/RecommendChannelListMobile.tsx
var RecommendChannelListMobile = __webpack_require__(81883);
;// CONCATENATED MODULE: ./src/app.feature/channel/component/modals/FollowingsModal/FollowingsModalMobile.tsx




function FollowingsModalMobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n\n  .hr {\n    width: 100%;\n    height: 1px;\n    background-color: #eee;\n  }\n  .channel-list {\n    overflow: scroll;\n  }\n"
    ]);
    FollowingsModalMobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var FollowingsModalMobile = function(_param) {
    var onClose = _param.onClose, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onClose"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onClose: onClose
    }, props), {
        animation: "left",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FollowingsModalMobile_StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(component_MobileHeader, {
                    onClose: onClose,
                    title: "팔로우한 채널"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hr"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "channel-list",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowingListMobile/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendChannelListMobile/* default */.Z, {})
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var FollowingsModal_FollowingsModalMobile = (FollowingsModalMobile);
var FollowingsModalMobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FollowingsModalMobile__StyledWrapper",
    componentId: "sc-925437e7-0"
})(FollowingsModalMobile_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/channel/component/ChannelNavbar/ChannelNavbar.mobile.tsx



function ChannelNavbar_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #fff;\n  border-bottom: 1px solid #e8e8e8;\n  border-top: 1px solid #eeeeee;\n\n  &.sticky {\n    position: sticky;\n    top: 61px;\n  }\n  .nav-content {\n    width: 100%;\n    max-width: 1148px;\n    height: 58px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 0 auto;\n    padding: 0 24px;\n    .lt {\n      display: flex;\n      gap: 32px;\n\n      & > .line-tab {\n        height: 58px;\n        align-items: center;\n        display: flex;\n        align-items: center;\n        gap: 32px;\n      }\n\n      .tab {\n        :hover {\n          color: #01a0ff;\n        }\n      }\n      .tab-my-channel {\n        font-size: 16px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        white-space: nowrap;\n        gap: 2px;\n        padding-left: 5px;\n        font-weight: 500;\n        .arrow-right {\n          font-size: 13px;\n          padding-top: 1px;\n        }\n\n        &::before {\n          content: '';\n          width: 1px;\n          height: 16px;\n          background-color: #666666;\n          margin-left: -6px;\n          margin-right: 20px;\n        }\n      }\n    }\n    .search-bar-wrapper {\n      opacity: 0;\n      padding: 8px 0;\n      width: 100%;\n      max-width: 780px;\n      transform: translate(0px, -60px);\n      transition: transform 0.3s ease, opacity 0.3s ease, max-width 0.3s ease;\n      &.visible {\n        opacity: 1;\n        width: 754px;\n        transform: translate(0px, 0px);\n      }\n      .search-bar {\n        height: 40px;\n        &:focus-within {\n          border: 1px solid #01a0ff;\n        }\n      }\n    }\n  }\n  ",
        " {\n    background-color: #fafafa;\n    &.sticky {\n      top: 0;\n    }\n    .nav-content {\n      gap: 0;\n      padding: 0 20px;\n      height: 50px;\n\n      .lt {\n        width: 100%;\n        gap: 0;\n\n        & > .line-tab {\n          height: 50px;\n          gap: 10px;\n          margin-left: -3px;\n          margin-right: 10px;\n        }\n\n        .tab {\n          width: fit-content;\n          padding: 15px 0;\n          font-size: 15px;\n        }\n\n        .tab-my-channel {\n          font-size: 15px;\n          gap: 0;\n          padding: 0;\n          margin-left: -4px;\n          .arrow-right {\n            width: 12px;\n            height: 12px;\n            margin-left: 4px;\n          }\n\n          &::before {\n            display: none;\n          }\n        }\n      }\n      .search-bar-mobile {\n        display: flex;\n        align-items: center;\n        flex-shrink: 0;\n\n        .search-modal-btn {\n          font-size: 13px;\n          align-items: center;\n          display: flex;\n          flex-shrink: 0;\n          cursor: pointer;\n\n          &.tag-btn {\n            &[data-active='true'] {\n              color: #01a0ff;\n              svg {\n                path {\n                  fill: #01a0ff;\n                }\n              }\n            }\n          }\n        }\n        .follow-divider {\n          height: 10px;\n          width: 1px;\n          background-color: #e8e8e8;\n          margin: 0 7px;\n        }\n        .search-btn {\n          cursor: pointer;\n          svg {\n            width: 16px;\n            height: 16px;\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    ChannelNavbar_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
























var ChannelNavbarMobile = function(param) {
    var _sticky = param.sticky, sticky = _sticky === void 0 ? false : _sticky, _searchBar = param.searchBar, searchBar = _searchBar === void 0 ? false : _searchBar, initialTab = param.initialTab, className = param.className, type = param.type;
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)(false), loginModalOpened = ref3[0], setLoginModalOpened = ref3[1];
    var currentUserQuery = (0,graphql/* useCurrentUserQuery */.rkO)();
    var isMobile = (0,useIsMobile/* default */.Z)();
    var isWebview = (0,useIsWebview/* default */.Z)();
    var tabs = [
        {
            id: 0,
            name: "채널홈",
            size: "43px",
            href: {
                pathname: (0,util/* getWebviewHref */.ys)("/channel", isWebview),
                query: {
                    tab: "home"
                }
            },
            gap: "32px"
        },
        {
            id: 1,
            name: "내 관심 소식",
            size: "77px",
            href: {
                pathname: (0,util/* getWebviewHref */.ys)("/channel", isWebview),
                query: {
                    tab: "interest"
                }
            }
        }, 
    ];
    var selectedTagIds = router.query.tags ? "".concat(router.query.tags).split(",") : [];
    var visibleSearchBar = (0,react.useMemo)(function() {
        if (searchBar === "visible") return true;
        if (searchBar === "unvisible") return false;
        return searchBar && sticky;
    }, [
        searchBar,
        sticky
    ]);
    var isChannelUser = (0,react.useMemo)(function() {
        var ref;
        return (0,utils/* getIsChannelUser */.P3)((ref = currentUserQuery.data) === null || ref === void 0 ? void 0 : ref.currentUser);
    }, [
        (ref = currentUserQuery.data) === null || ref === void 0 ? void 0 : ref.currentUser
    ]);
    var tabActive = router.pathname === "/channel" || router.pathname === "/webview/channel";
    var handleOpenModal = function(modal) {
        if (modal === "following" && isWebview) {
            router.push("/webview/channel/followings");
        } else if (modal === "search" && isWebview) {
            router.push({
                pathname: "/webview/channel/search",
                query: {
                    back: router.query.back ? router.query.back : router.asPath
                }
            });
        } else {
            router.push({
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    modal: modal
                })
            });
        }
    };
    var handleCloseModal = function() {
        router.push({
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                modal: "close"
            })
        });
    };
    var checkTab = function(menu) {
        var ref;
        if (menu.id === 1 && !((ref = currentUserQuery.data) === null || ref === void 0 ? void 0 : ref.currentUser)) {
            setLoginModalOpened(true);
            return false;
        }
        return true;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChannelNavbar_mobile_StyledWrapper, {
        className: (0,clsx_m/* default */.Z)(className, {
            sticky: sticky
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "nav-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lt",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LineTabs/* default */.Z, {
                                className: "line-tab",
                                data: tabs,
                                initialTab: initialTab ? tabs[initialTab] : undefined,
                                active: tabActive,
                                disableGlider: isMobile,
                                checkTab: checkTab
                            }),
                            ((ref1 = currentUserQuery.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.currentUser) === null || ref2 === void 0 ? void 0 : ref2.channel) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (0,util/* getWebviewHref */.ys)("/channel/".concat(currentUserQuery.data.currentUser.channel.url), isWebview),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "tab-my-channel",
                                    children: [
                                        isMobile ? "내 채널" : "내 채널 바로가기",
                                        isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* ArrowRight */.ol, {
                                            className: "arrow-right"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "search-bar-wrapper desktop ".concat(visibleSearchBar ? "visible" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelSearchbar/* default */.Z, {
                            className: "search-bar"
                        })
                    }),
                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "search-bar-mobile mobile",
                        children: [
                            type === "home" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "search-modal-btn tag-btn",
                                "data-active": selectedTagIds.length !== 0,
                                onClick: function() {
                                    return handleOpenModal("tag");
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "태그로 보기"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons_TagFilterBtn, {
                                        color: selectedTagIds.length === 0 ? "#333" : "#01a0ff"
                                    })
                                ]
                            }),
                            type === "interest" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "search-modal-btn",
                                onClick: function() {
                                    return handleOpenModal("following");
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "팔로우한 채널"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons_ChannelCardListBtn, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "follow-divider"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "search-btn",
                                onClick: function() {
                                    return handleOpenModal("search");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MagnifyingGlass/* default */.Z, {})
                            })
                        ]
                    })
                ]
            }),
            isMobile && type === "home" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelFeedTagBox_TagBottomSheet, {
                open: router.query.modal === "tag",
                onClose: handleCloseModal
            }),
            isMobile && type === "interest" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowingsModal_FollowingsModalMobile, {
                open: router.query.modal === "following",
                onClose: handleCloseModal
            }),
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(screen_ScreenChannelSearchModal, {
                open: router.query.modal === "search",
                onClose: handleCloseModal
            }),
            isMobile && isChannelUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelOwnerCard/* default */.Z, {
                sticky: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginAlert/* default */.Z, {
                DialogProps: {
                    open: loginModalOpened
                },
                onRequestClose: function() {
                    return setLoginModalOpened(false);
                }
            })
        ]
    });
};
/* harmony default export */ var ChannelNavbar_mobile = (ChannelNavbarMobile);
var ChannelNavbar_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ChannelNavbar.mobile__StyledWrapper",
    componentId: "sc-7bd7cf6-0"
})(ChannelNavbar_mobile_templateObject(), media/* mobileBreakPoint */.vm);


/***/ }),

/***/ 62618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30132);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47079);
/* harmony import */ var _app_components_modals_ChannelDeactivatedModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99078);
/* harmony import */ var _app_components_modals_ChannelUnavailableModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26905);
/* harmony import */ var app_styled_media__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68250);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15125);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  z-index: 1;\n  &[data-sticky='true'] {\n    position: sticky;\n    top: -1px;\n  }\n  .desktop-card {\n    height: 50px;\n    background-color: #003056;\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 12px 0;\n    border-radius: 5px;\n    margin-bottom: 16px;\n    img {\n      width: 35px;\n    }\n    .owner-banner-message {\n      font-size: 18px;\n      font-weight: 500;\n      z-index: 2;\n      line-height: 1.33;\n      letter-spacing: -0.72px;\n      margin: 0 20px 0 8px;\n    }\n    .owner-banner-btn {\n      background-color: white;\n      border-radius: 40px;\n      color: #003056;\n      font-size: 14px;\n      font-weight: bold;\n      padding: 6px 16px;\n      cursor: pointer;\n    }\n  }\n  .mobile-card {\n    display: none;\n    height: 40px;\n    justify-content: center;\n    align-items: center;\n    background-color: #003056;\n    color: #fff;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 1.71;\n    letter-spacing: -0.56px;\n  }\n  ",
        " {\n    .desktop-card {\n      display: none;\n    }\n    .mobile-card {\n      display: flex;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var ChannelOwnerCard = function(param) {
    var _sticky = param.sticky, sticky = _sticky === void 0 ? false : _sticky, content = param.content, className = param.className;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), stucked = ref[0], setStucked = ref[1];
    var targetRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), unavailableModalVisible = ref1[0], setUnavailableModalVisible = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), deactivatedModalVisible = ref2[0], setDeactivatedModalVisible = ref2[1];
    var data = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_3__/* .useCurrentUserQuery */ .rkO)().data;
    var handleClickRegist = function() {
        var ref, ref1;
        if (!(data === null || data === void 0 ? void 0 : (ref = data.currentUser) === null || ref === void 0 ? void 0 : ref.channel)) {
            setUnavailableModalVisible(true);
        } else if (data === null || data === void 0 ? void 0 : (ref1 = data.currentUser) === null || ref1 === void 0 ? void 0 : ref1.channel.deactivatedAt) {
            setDeactivatedModalVisible(true);
        } else {
            window.open("https://".concat(utils_config__WEBPACK_IMPORTED_MODULE_7__/* .LINKAREER_BIZ_BASE_URL */ .Sn, "/channel"));
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(param, 1), e = _param[0];
            if (e.intersectionRatio < 1) {
                setStucked(true);
            } else {
                setStucked(false);
            }
        }, {
            threshold: [
                1
            ]
        });
        if (sticky && targetRef.current) {
            observer.observe(targetRef.current);
        }
        return function() {
            observer.disconnect();
        };
    }, [
        sticky,
        targetRef
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        className: className,
        ref: targetRef,
        "data-sticky": sticky,
        "data-stucked": stucked,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "mobile-card",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "owner-banner-message",
                    children: content || "내 채널 관리는 PC에서 이용 가능합니다."
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "desktop-card",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                            src: "/static/images/channel/banner_notice.png",
                            alt: "소식 등록"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "owner-banner-message",
                        children: content || "소식을 등록하고 회원들과 교류하면, 지원자를 더 많이 늘릴 수 있습니다."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "owner-banner-btn",
                        onClick: handleClickRegist,
                        children: "소식 등록하러 가기"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_modals_ChannelUnavailableModal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                open: unavailableModalVisible,
                onClose: function() {
                    return setUnavailableModalVisible(false);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_modals_ChannelDeactivatedModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                open: deactivatedModalVisible,
                onClose: function() {
                    return setDeactivatedModalVisible(false);
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ChannelOwnerCard);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ChannelOwnerCard__StyledWrapper",
    componentId: "sc-15bd4db1-0"
})(_templateObject(), app_styled_media__WEBPACK_IMPORTED_MODULE_6__/* .mobileBreakPoint */ .vm);


/***/ }),

/***/ 11834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44119);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(graphql_tag__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var immutability_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7145);
/* harmony import */ var immutability_helper__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(immutability_helper__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30132);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47079);
/* harmony import */ var _app_modules_hooks_useIntersect__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23913);
/* harmony import */ var _cards_ChannelCard_ChannelCard__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87645);
/* harmony import */ var _cards_ChannelCard_ChannelCardLoading__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27662);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query gqlFollowListModalMobile($first: Int, $after: String) {\n    viewerFollowingFeed(first: $first, after: $after) {\n      totalCount\n      nodes {\n        ...channelCard_channel\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 16px;\n  padding: 12px 20px 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  .nothing-content {\n    padding: 2px 0 12px;\n    border-bottom: 1px solid #e8e8e8;\n    margin-bottom: 5px;\n    span {\n      color: #01a0ff;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










graphql_tag__WEBPACK_IMPORTED_MODULE_3___default()(_templateObject());
// TODO: cursor기반 pagination 이 제공되면 무한 스크룰 적용 예정
var skeletonArr = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    ""
];
var FollowingListMobile = function() {
    var ref = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .useGqlFollowListModalMobileQuery */ .l21)({
        variables: {
            first: 10
        },
        fetchPolicy: "cache-and-network"
    }), data = ref.data, loading = ref.loading, error = ref.error, fetchMore = ref.fetchMore;
    var hasNextPage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref;
        if (!data) return null;
        return (ref = data.viewerFollowingFeed) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage;
    }, [
        data
    ]);
    var lastCursor = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref;
        if (!data) return null;
        return (ref = data.viewerFollowingFeed) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor;
    }, [
        data
    ]);
    var handleIntersect = function() {
        // validation
        if (!hasNextPage || !lastCursor || loading) return;
        var variables = {
            first: 10,
            after: lastCursor
        };
        if (!fetchMore) return;
        fetchMore({
            variables: variables,
            updateQuery: function(previousQueryResult, param) {
                var fetchMoreResult = param.fetchMoreResult;
                if (!fetchMoreResult || !fetchMoreResult.viewerFollowingFeed) return previousQueryResult;
                var result = immutability_helper__WEBPACK_IMPORTED_MODULE_4___default()(previousQueryResult, {
                    viewerFollowingFeed: {
                        nodes: {
                            $push: fetchMoreResult.viewerFollowingFeed.nodes
                        },
                        pageInfo: {
                            $set: fetchMoreResult.viewerFollowingFeed.pageInfo
                        }
                    }
                });
                return result;
            }
        });
    };
    var target = (0,_app_modules_hooks_useIntersect__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(handleIntersect, [
        lastCursor,
        loading,
        fetchMore
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            function() {
                var ref;
                // loading
                if (!data && loading) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: skeletonArr.map(function(_, idx) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_cards_ChannelCard_ChannelCardLoading__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}, idx);
                    })
                });
                // error
                if (error) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: skeletonArr.map(function(_, idx) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_cards_ChannelCard_ChannelCardLoading__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}, idx);
                    })
                });
                // empty
                if (!(data === null || data === void 0 ? void 0 : (ref = data.viewerFollowingFeed) === null || ref === void 0 ? void 0 : ref.nodes.length)) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "nothing-content",
                    children: [
                        "아직 팔로우한 채널이 없습니다. ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            children: "링커리어가 추천하는 채널을 팔로우 해보세요!"
                        })
                    ]
                });
                // view
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: data === null || data === void 0 ? void 0 : data.viewerFollowingFeed.nodes.filter(function(el) {
                        return !!el;
                    }).map(function(channelCardData) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "channel",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_cards_ChannelCard_ChannelCard__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                enableNewBadge: true,
                                data: channelCardData
                            })
                        }, "FollowingListMobile-".concat(channelCardData.id));
                    })
                });
            }(),
            hasNextPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                ref: target
            }),
            hasNextPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_cards_ChannelCard_ChannelCardLoading__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FollowingListMobile);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FollowingListMobile__StyledWrapper",
    componentId: "sc-a7f632f9-0"
})(_templateObject1());


/***/ }),

/***/ 81883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44119);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(graphql_tag__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var immutability_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7145);
/* harmony import */ var immutability_helper__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(immutability_helper__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30132);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47079);
/* harmony import */ var _app_modules_hooks_useIntersect__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23913);
/* harmony import */ var _cards_ChannelCard_ChannelCard__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87645);
/* harmony import */ var _cards_ChannelCard_ChannelCardLoading__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27662);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query gqlRecommendChannelListMobile($first: Int, $after: String) {\n    recommendChannelFeed(first: $first, after: $after) {\n      totalCount\n      nodes {\n        ...channelCard_channel\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 20px;\n  padding-top: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  .nothing-content {\n    font-size: 12px;\n    padding: 15px 20px;\n    border-bottom: 1px solid #e8e8e8;\n    margin-bottom: 5px;\n    span {\n      color: #01a0ff;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










graphql_tag__WEBPACK_IMPORTED_MODULE_3___default()(_templateObject());
// TODO: cursor기반 pagination 이 제공되면 무한 스크룰 적용 예정
var skeletonArr = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    ""
];
var RecommendChannelListMobile = function() {
    var ref = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .useGqlRecommendChannelListMobileQuery */ .Tb5)({
        variables: {
            first: 10
        },
        fetchPolicy: "cache-and-network"
    }), data = ref.data, loading = ref.loading, error = ref.error, fetchMore = ref.fetchMore;
    var hasNextPage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref;
        if (!data) return null;
        return (ref = data.recommendChannelFeed) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage;
    }, [
        data
    ]);
    var lastCursor = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref;
        if (!data) return null;
        return (ref = data.recommendChannelFeed) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor;
    }, [
        data
    ]);
    var handleIntersect = function() {
        // validation
        if (!hasNextPage || !lastCursor || loading) return;
        var variables = {
            first: 10,
            after: lastCursor
        };
        if (!fetchMore) return;
        fetchMore({
            variables: variables,
            updateQuery: function(previousQueryResult, param) {
                var fetchMoreResult = param.fetchMoreResult;
                if (!fetchMoreResult || !fetchMoreResult.recommendChannelFeed) return previousQueryResult;
                var result = immutability_helper__WEBPACK_IMPORTED_MODULE_4___default()(previousQueryResult, {
                    recommendChannelFeed: {
                        nodes: {
                            $push: fetchMoreResult.recommendChannelFeed.nodes
                        },
                        pageInfo: {
                            $set: fetchMoreResult.recommendChannelFeed.pageInfo
                        }
                    }
                });
                return result;
            }
        });
    };
    var target = (0,_app_modules_hooks_useIntersect__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(handleIntersect, [
        lastCursor,
        loading,
        fetchMore
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            function() {
                // loading
                if (!data && loading) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: skeletonArr.map(function(_, idx) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_cards_ChannelCard_ChannelCardLoading__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}, idx);
                    })
                });
                // error
                if (error) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: skeletonArr.map(function(_, idx) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_cards_ChannelCard_ChannelCardLoading__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}, idx);
                    })
                });
                // view
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: data === null || data === void 0 ? void 0 : data.recommendChannelFeed.nodes.filter(function(el) {
                        return !!el;
                    }).map(function(channelCardData) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "channel",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_cards_ChannelCard_ChannelCard__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                enableNewBadge: true,
                                data: channelCardData
                            })
                        }, "RecommendChannelListMobile-".concat(channelCardData.id));
                    })
                });
            }(),
            hasNextPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                ref: target
            }),
            hasNextPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_cards_ChannelCard_ChannelCardLoading__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RecommendChannelListMobile);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "RecommendChannelListMobile__StyledWrapper",
    componentId: "sc-948b3093-0"
})(_templateObject1());


/***/ }),

/***/ 80549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function ResetTag() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        "aria-label": "태그 초기화",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("desc", {
                children: "태그 초기화"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                "data-name": "그룹 11774",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h16v16H0z",
                        "data-name": "사각형 10133"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#333",
                        d: "M8.242 3.001a5.063 5.063 0 00-5.236 4.895 5.2 5.2 0 001.3 3.715l-.672.1a.641.641 0 00-.526.732.632.632 0 00.618.548.654.654 0 00.092-.007l2.69-.414-.141-2.685a.632.632 0 00-.658-.608.638.638 0 00-.591.678l.036.7a3.9 3.9 0 01-.9-2.695 3.752 3.752 0 117.491.373 3.849 3.849 0 01-1.967 3.214.654.654 0 00-.253.872.622.622 0 00.551.338.6.6 0 00.3-.077 5.186 5.186 0 00-2.132-9.678z",
                        "data-name": "패스 1070"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ResetTag);


/***/ })

}]);